<template>
  <div
    v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_case_escalation_stage')"
  >
    <div class="box box-primary">
      <div class="box-header">
        <h3 class="box-title">{{ $t("escalationstage.title") }}</h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="row section-container">
            <div class="row">
              <div class="section-header">
                <strong>{{ $t("escalationstage.addnew") }}</strong>
                <button
                  type="button"
                  v-if="
                    GET_ACCOUNT_DATA.id == 1 ||
                      has_perm('create_case_escalation_stage')
                  "
                  class="btn btn-default btn-sm"
                  @click="onOpenStageInput"
                >
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="row" v-show="stageinput">
              <escalationstage-input
                @save="onSaveStageInput"
                @close="onHideStageInput"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row section-container">
            <div class="row">
              <div class="section-header">
                <strong>{{ $t("escalationstage.list") }}</strong>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 table-responsive">
                <table class="table table-hover">
                  <thead>
                    <th>{{ $t("escalationstage.name") }}</th>
                    <th>{{ $t("escalationstage.stage_due_date_no") }}</th>
                    <th>{{ $t("escalationstage.stage_poc") }}</th>
                    <th>{{ $t("common.action") }}</th>
                  </thead>
                  <tbody>
                    <tr v-for="stage in escalation_stage_items" :key="stage.id">
                      <td class="col-sm-3 col-md-3 col-lg-3">
                        <div v-if="stage !== selectedEscalationStage">
                          {{ stage.name }}
                        </div>
                        <div v-else>
                          <input
                            type="text"
                            v-model="stage.name"
                            class="resize-width"
                          />
                        </div>
                      </td>
                      <td class="col-sm-3 col-md-3 col-lg-3">
                        <div v-if="stage !== selectedEscalationStage">
                          {{ stage.stage_due_date_no }}
                        </div>
                        <div v-else>
                          <input
                            type="number"
                            v-model="stage.stage_due_date_no"
                            class="resize-width"
                          />
                        </div>
                      </td>
                      <td class="col-sm-3 col-md-3 col-lg-3">
                        <div v-if="stage !== selectedEscalationStage">
                          {{ stage.stage_poc_fullname }}
                        </div>
                        <div v-else>
                          <b-form-select
                            :options="staffs"
                            v-model="stage.stage_poc"
                            class="resize-width height-26"
                          />
                        </div>
                      </td>
                      <td class="col-sm-3 col-md-3 col-lg-3">
                        <div
                          class="btn-group"
                          v-if="stage !== selectedEscalationStage"
                        >
                          <button
                            type="button"
                            v-if="
                              GET_ACCOUNT_DATA.id == 1 ||
                                has_perm('update_case_escalation_stage')
                            "
                            class="btn btn-sm btn-info"
                            @click="onEditEscalationStage(stage)"
                          >
                            <i class="fa fa-edit"></i>
                          </button>
                        </div>
                        <div class="btn-group" v-else>
                          <button
                            type="button"
                            v-if="
                              GET_ACCOUNT_DATA.id == 1 ||
                                has_perm('update_case_escalation_stage')
                            "
                            class="btn btn-sm btn-success"
                            @click="onSaveStageInput(stage)"
                          >
                            <i class="fa fa-save"></i>
                          </button>
                        </div>
                        <div class="btn-group">
                          <button
                            type="button"
                            v-if="
                              GET_ACCOUNT_DATA.id == 1 ||
                                has_perm('delete_case_escalation_stage')
                            "
                            class="btn btn-sm btn-warning"
                            @click="onDeleteEscalationStage(stage)"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Delet Confirm Modal Component -->
    <div class="modal fade" id="modal-escalationstage-delete">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("escalationstage.deletetitle") }}</h4>
          </div>
          <div class="modal-body">{{ $t("escalationstage.deletemsg") }}</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              style="background-color: #f29911;border-color: #f29911;color:#fff"
            >
              {{ $t("common.back") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-green"
              @click="onConfirmDelete"
            >
              {{ $t("common.confirm") }}
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </div>
</template>

<script>
import utils from '@/lib/utils';
import { mapGetters, mapActions } from "vuex";
import EscalationStageInput from "./EscalationStageInput.vue";

export default {
  name: "EscalationStage",
  data() {
    return {
      editMode: false,
      users: [
        { name: "mimi", email: "wewe@s.com", edit: true },
        { name: "sam", email: "some@mk.com", edit: false },
        { name: "kev", email: "wewe", edit: false }
      ],
      editedUser: null,
      escalation_stage_fields: [
        {
          key: "name",
          label: "escalationstage.name",
          sortable: true,
          class: "text-center"
        },
        {
          key: "stage_due_date_no",
          label: "escalationstage.stage_due_date_no",
          sortable: true,
          class: "text-center"
        },
        {
          key: "stage_poc",
          label: "escalationstage.stage_poc",
          sortable: true,
          class: "text-center"
        },
        {
          key: "actions",
          label: "common.action",
          sortable: true,
          class: "text-center"
        }
      ],
      selectedEscalationStage: null,
      stageinput: false,
      staffs: [],
      escalation_stage_id: 0
    };
  },
  watch: {
    selectedEscalationStage: function() {
      if (this.selectedEscalationStage == null) {
        this.escalation_stage_id = 0;
      } else {
        this.escalation_stage_id =
          this.selectedEscalationStage.id !== 0
            ? this.selectedEscalationStage.id
            : 0;
      }
    },
    STAFF_LIST: function() {
      let staffList = this.STAFF_LIST;
      let staffs = [];
      staffList.forEach(data => {
        let full_name = `${data.last_name} ${data.first_name}`;
        let item = {
          value: data.id,
          text: full_name
        };
        staffs.push(item);
      });
      this.staffs = staffs;
    }
  },
  computed: {
    ...mapGetters([
      "ESCALATION_STAGE_LIST",
      "STAFF_LIST",
      "GET_ACCOUNT_DATA"
    ]),
    escalation_stage_items: function() {
      let items = [];
      this.ESCALATION_STAGE_LIST.forEach(v => {
        let id = v.id;
        let name = v.name;
        let stage_due_date_no = v.stage_due_date_no;
        let stage_poc = v.stage_poc;
        let stage_poc_fullname =
          v.poc_details !== null
            ? `${v.poc_details.last_name} ${v.poc_details.first_name}`
            : null;
        let item = {
          id: id,
          name: name,
          stage_due_date_no: stage_due_date_no,
          stage_poc: stage_poc,
          stage_poc_fullname: stage_poc_fullname
        };

        items.push(item);
      });
      return items;
    },
    hasItemsInEdit() {
      return this.escalation_stage_items.filter(ele => ele.inEdit).length > 0;
    }
  },
  methods: {
    ...mapActions([
      "GET_ESCALATION_STAGE_LIST",
      "DELETE_ESCALATION_STAGE",
      "ADD_ESCALATION_STAGE",
      "UPDATE_ESCALATION_STAGE",
      "GET_STAFF_LIST"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onOpenStageInput() {
      this.stageinput = true;
      this.selectedEscalationStage = null;
    },
    onHideStageInput() {
      this.stageinput = false;
    },
    onSaveStageInput(data) {
      let payload = {
        id: this.escalation_stage_id,
        data: data
      };

      if (payload.id == 0) {
        this.ADD_ESCALATION_STAGE(payload).then(
          function() {
            this.GET_ESCALATION_STAGE_LIST().then(
              function() {
                this.onHideStageInput();
              }.bind(this)
            );
          }.bind(this)
        );
      } else {
        this.UPDATE_ESCALATION_STAGE(payload).then(
          function() {
            this.GET_ESCALATION_STAGE_LIST().then(
              function() {
                this.onHideStageInput();
              }.bind(this)
            );
          }.bind(this)
        );
      }
    },
    onEditEscalationStage(data) {
      this.selectedEscalationStage = data;
    },
    onDeleteEscalationStage(item) {
      $("#modal-escalationstage-delete").modal("show");
      this.onDeletedEscalation = item;
    },
    onConfirmDelete: function() {
      $("#modal-escalationstage-delete").modal("hide");
      let data = {
        id: this.onDeletedEscalation.id
      };
      this.DELETE_ESCALATION_STAGE(data)
        .then(
          function() {
            this.GET_ESCALATION_STAGE_LIST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    }
  },
  components: {
    "escalationstage-input": EscalationStageInput
  },
  mounted() {
    this.GET_ESCALATION_STAGE_LIST().then(
      function() {
        this.GET_STAFF_LIST();
      }.bind(this)
    );
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.section-container {
  margin-bottom: 25px;
}

.section-header {
  margin: 10px 0 20px 0;
  padding-bottom: 9px;
  border-bottom: 1px solid #eee;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
}

.resize-width {
  width: 100%;
}

.height-26 {
  height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/views/Case/EscalationStage.vue